<ng-container *ngIf="selfElement$ | async as selfElement">
	<stages-process-element-properties
		[translateNone]="translateNone"
		[propertyList]="propertyList"
		[currentElement]="$any(selfElement)"
	></stages-process-element-properties>
</ng-container>
